/*
 * Copyright (c) 2022. CodeGen International (Pvt) Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of CodeGen
 * International (Pvt) Ltd. ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with CodeGen International.
 *
 */
import * as tslib_1 from "tslib";
import { KeyControlAndAbstractSearchCriteria } from './key-control-and-abstract-search-criteria';
/**
 * @author lakshan
 * @since 08 Nov, 2022
 */
var JobParameterSearchCriteria = /** @class */ (function (_super) {
    tslib_1.__extends(JobParameterSearchCriteria, _super);
    function JobParameterSearchCriteria() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.jobName = '';
        _this.parameterName = '';
        return _this;
    }
    return JobParameterSearchCriteria;
}(KeyControlAndAbstractSearchCriteria));
export { JobParameterSearchCriteria };
